import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import "./Login.css";

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsSubmitting(true);
    try {
      const response = await fetch("https://cur.abduls.at/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      // Read as text first so a non-JSON response doesn't crash the app.
      const raw = await response.text();
      let data;
      try {
        data = JSON.parse(raw);
      } catch (parseError) {
        console.error(
          `Login-Server hat kein gueltiges JSON zurueckgegeben (Status ${response.status}):`,
          raw
        );
        setErrorMessage(
          `Server-Antwort war kein gueltiges JSON (Status ${response.status}). Details in der Konsole.`
        );
        return;
      }

      if (data.success) {
        login(username, data.token, data.full_name);
        navigate("/app");
      } else {
        setErrorMessage("Username oder Passwort ist falsch.");
      }
    } catch (networkError) {
      console.error("Login-Anfrage fehlgeschlagen:", networkError);
      setErrorMessage("Login-Anfrage fehlgeschlagen (Netzwerk- oder CORS-Fehler).");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-brand-icon">📚</div>
          <div className="login-title">ECTS Tracker</div>
        </div>
        <p className="login-subtitle">Melde dich an, um deinen Studienfortschritt zu sehen.</p>

        <form onSubmit={handleSubmit}>
          {errorMessage && (
            <div className="login-error" role="alert">
              {errorMessage}
            </div>
          )}

          <div className="login-field">
            <label className="login-label" htmlFor="login-username">
              Username
            </label>
            <div className="login-input-wrap">
              <input
                id="login-username"
                className="login-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="dein-username"
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div className="login-field">
            <label className="login-label" htmlFor="login-password">
              Passwort
            </label>
            <div className="login-input-wrap">
              <input
                id="login-password"
                className="login-input login-input--with-toggle"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="login-toggle-visibility"
                onClick={() => setShowPassword((v) => !v)}
                tabIndex={-1}
              >
                {showPassword ? "verbergen" : "anzeigen"}
              </button>
            </div>
          </div>

          <button className="login-submit" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Wird angemeldet…" : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
